import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { useQuery } from '@tanstack/react-query'
import { getDynamicFields } from 'services/DynamicFieldsService'
import { DynamicFieldsSection } from 'types/dynamicFields'

export const useDynamicFieldsQuery = (sections: DynamicFieldsSection[]) => {
  return useQuery({
    enabled: !!sections?.length,
    queryKey: reactQueryKeys.dynamicFields(),
    queryFn: () => getDynamicFields(sections),
  })
}
